/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgKey = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m17 3.586 4.207 4.207-1.414 1.414L17 6.414 15.414 8l2.293 2.293-1.414 1.414L14 9.414l-1.555 1.555a6 6 0 1 1-1.584-1.245zM8 11a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgKey as Key };
